<aside class="sidebar" [class.is-collapsed]="collapsed()">
  <div class="sidebar-header">
    <a [routerLink]="['/internal']" class="brand">
      <img src="assets/brand/logo-bro.svg" alt="Bienes Raíces del Oriente" class="logo logo-full">
      <img src="assets/brand/isotipo-bro.svg" alt="Bienes Raíces del Oriente" class="logo logo-mark">
      <span class="brand-name">Admin</span>
    </a>
    <button
      type="button"
      class="collapse-btn"
      [attr.aria-label]="collapsed() ? 'Mostrar menú lateral' : 'Ocultar menú lateral'"
      [attr.aria-expanded]="!collapsed()"
      aria-controls="sidebar-nav"
      (click)="toggleCollapsed.emit()">
      <mat-icon aria-hidden="true">{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
  </div>

  <nav class="sidebar-nav" id="sidebar-nav">
    <ul>
      @for (item of menuItems(); track item) {
        <li>
          <!-- Item con hijos -->
          @if (item.children && hasVisibleChildren(item)) {
            <div class="nav-item-group">
              <div class="nav-item-header" (click)="toggleSubmenu(item)" [class.expanded]="item.expanded">
                <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
                <span class="nav-label">{{ item.label }}</span>
                <mat-icon class="arrow-icon">expand_more</mat-icon>
              </div>
              <ul class="sub-menu" [class.collapsed]="!item.expanded">
                @for (child of item.children; track child) {
                  <li>
                    @if (shouldShow(child)) {
                      <a
                        [routerLink]="child.route"
                        routerLinkActive="active"
                        class="nav-link sub-link"
                        [attr.title]="collapsed() ? child.label : null">
                        <mat-icon class="nav-icon">{{ child.icon }}</mat-icon>
                        <span>{{ child.label }}</span>
                      </a>
                    }
                  </li>
                }
              </ul>
            </div>
          }
          <!-- Item sin hijos -->
          @if (!item.children && shouldShow(item)) {
            <a
              [routerLink]="item.route"
              routerLinkActive="active"
              class="nav-link"
              [attr.title]="collapsed() ? item.label : null">
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          }
        </li>
      }
    </ul>
  </nav>

  <div class="sidebar-footer">
    <div class="user-info">
      <div class="user-avatar">
        {{ currentUser()?.name?.charAt(0) | uppercase }}
      </div>
      <div class="user-details">
        <span class="user-name">{{ currentUser()?.name }}</span>
        <span class="user-role">{{ isAdmin() ? 'Administrador' : 'Agente' }}</span>
      </div>
    </div>
    <button class="logout-btn" (click)="logout()" [attr.title]="collapsed() ? 'Cerrar sesión' : null">
      <mat-icon>logout</mat-icon>
      <span>Cerrar sesión</span>
    </button>
  </div>
</aside>
